import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { StyleSheet, css } from 'aphrodite';
import { Theme } from '../../config/theme';

import Button from '../Button';

export default class ResourceCard extends Component {
  render() {
    return (
      <a
        rel="noopener noreferrer"
        href={this.props.link}
        target="_blank"
        className={css(styles.card)}>
        <div className={css(styles.card_title)}>{this.props.title}</div>
        <div className={css(styles.card_date)}>{this.props.date}</div>
        <div className={css(styles.card_summary)}>{this.props.summary}</div>
        <Button title="Download file" styles={styles.button} />
      </a>
    );
  }
}

ResourceCard.defaultProps = {
  status: null,
  signup: false,
  interests: [],
};

ResourceCard.propTypes = {
  link: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  summary: PropTypes.string.isRequired,
};

const styles = StyleSheet.create({
  button: {
    width: '100%',
  },
  card: {
    position: 'relative',
    display: 'inline-block',
    width: 250,
    minWidth: 250,
    padding: 18,
    margin: '0 15px 23px',
    backgroundColor: Theme.white,
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.05)',
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: Theme.lighter_grey,
    transition: 'all 300ms',

    ':hover': {
      transform: 'translateY(-5px)',
      boxShadow: '0 6px 11px 0 rgba(0, 0, 0, 0.05)',
    },
  },
  card_title: {
    marginBottom: 10,
    fontFamily: Theme.font_family_heading,
    fontWeight: Theme.font_weight_heading,
    fontSize: 20,
    color: Theme.black,
    lineHeight: 1.4,
  },
  card_date: {
    marginBottom: 15,
    fontFamily: Theme.font_family_primary,
    fontWeight: Theme.font_weight_primary,
    fontSize: 14,
    color: '#828282',

    [Theme.mobile_query]: {
      marginBottom: 0,
    },
  },
  card_summary: {
    marginBottom: 12.7,
    fontFamily: Theme.font_family_primary,
    fontWeight: Theme.font_weight_primary,
    fontSize: 14,
    lineHeight: 1.4,
    color: '#021a36',
  },
});



// WEBPACK FOOTER //
// ./src/components/ResourceCard/index.js